import useNavigationMenu from '@Guidelines/Shell/AppShell/Hooks/useNavigationMenu';
import resolveActiveNavigation, { type ActiveNavigation } from '@UI/Routing/resolveActiveNavigation';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

const useActiveNavigation = (): ActiveNavigation | null => {
	const { pathname } = useLocation();
	const { menu } = useNavigationMenu();

	return React.useMemo(() => resolveActiveNavigation(pathname, menu), [pathname, menu]);
};

export default useActiveNavigation;
